import { useTranslations } from 'next-intl'

import AnimatedSectionTitle from '~/components/atoms/AnimatedSectionTitle/AnimatedSectionTitle'
import Button, { ButtonVariants } from '~/components/atoms/Button/Button'
import Container from '~/components/atoms/Container/Container'
import LogoMarquee from '~/components/atoms/LogoMarquee/LogoMarquee'
import VerticalPadder from '~/components/atoms/VerticalPadder/VerticalPadder'
import { pressLogos } from '~/mock-data/press-logos'

import styles from './AsSeenIn.module.css'
const pressLogosData: any = pressLogos

export interface AsSeenInProps {
  testID?: string
  noText?: boolean
}

export default function AsSeenIn({ testID, noText = false }: AsSeenInProps) {
  const t = useTranslations('asSeenIn')

  return (
    <div className={styles.base} data-testid={testID}>
      <VerticalPadder noPaddingTop={noText} noPaddingBottom={noText}>
        {!noText && (
          <Container>
            <div className={styles.title}>
              <AnimatedSectionTitle tag="h4">{t('title')}</AnimatedSectionTitle>
              <Button
                variant={ButtonVariants.textLinkSmallUnderline}
                link={'/press'}
                className={styles.viewAllButton}
              >
                {t('viewPress')}
              </Button>
            </div>
          </Container>
        )}
        <div className={styles.logoContainer}>
          <LogoMarquee data={pressLogosData} />
        </div>
      </VerticalPadder>
    </div>
  )
}
